var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent } from 'react';
import Block from '../block';
import Background from '../../elements/background/background';
import { FRAME_STYLE } from '../../../../data-parser/div-cards/props/frame';
import { sizeTraitToCssUnit, sizeTraitToClassMode } from '../../util';
import * as CLS from './cls';

var ContainerBlockContent = function (_PureComponent) {
    _inherits(ContainerBlockContent, _PureComponent);

    function ContainerBlockContent() {
        _classCallCheck(this, ContainerBlockContent);

        return _possibleConstructorReturn(this, (ContainerBlockContent.__proto__ || Object.getPrototypeOf(ContainerBlockContent)).apply(this, arguments));
    }

    _createClass(ContainerBlockContent, [{
        key: 'render',
        value: function render() {
            var props = this.props;
            var renderChildren = props.renderChildren,
                onAction = props.onAction;


            return React.createElement(
                'div',
                {
                    className: this.className,
                    style: this.frameStyle,
                    onClick: props.onClick
                },
                React.createElement(Background, {
                    background: props.background
                }),
                renderChildren && props.children.map(function (block, index) {
                    return React.createElement(Block, {
                        key: index,
                        onAction: onAction,
                        block: block
                    });
                })
            );
        }
    }, {
        key: 'frameStyle',
        get: function get() {
            var props = this.props;

            var style = {
                width: sizeTraitToCssUnit(props.width),
                height: sizeTraitToCssUnit(props.height),
                marginLeft: sizeTraitToCssUnit(props.marginLeft, '0'),
                marginRight: sizeTraitToCssUnit(props.marginRight, '0')
            };

            var frame = props.frame;


            if (!frame) {
                return style;
            }

            switch (frame.style) {
                case FRAME_STYLE.border:
                    style.border = '1px solid ' + frame.color;
                    break;
                case FRAME_STYLE.onlyRoundCorners:
                    style.border = 'none';
            }

            return style;
        }
    }, {
        key: 'className',
        get: function get() {
            var props = this.props;
            var horizontalAlignment = props.horizontalAlignment,
                verticalAlignment = props.verticalAlignment,
                direction = props.direction;


            var frame = props.frame ? props.frame.style : '';
            var modes = _extends({
                horizontalAlignment: horizontalAlignment,
                verticalAlignment: verticalAlignment,
                direction: direction,
                frame: frame,
                placeholder: !props.renderChildren
            }, sizeTraitToClassMode(props.height));

            return CLS.block(modes).mix(props.baseClass)();
        }
    }]);

    return ContainerBlockContent;
}(PureComponent);

export default ContainerBlockContent;